/**
 *
 */
export enum Statuses {
  Student = 1,
  WorkingStudent = 2,
  Working = 4,
  LookingForJob = 8,
}
